<!-- <p>edit-asset-datapoint works!</p> -->
<app-dialog-header headerIcon="sensors" headerText="Modify {{dialogData.SensorName}} Datapoint"
	(onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div class="frmcontainer">
		<div class="frmLeft">
			<div mat-dialog-content>
				<mat-form-field>
					<mat-label>Name:</mat-label>
					<input matInput autocomplete="off" formControlName="PVName" required>
					<mat-error *ngIf="dialogForm.get('PVName')!.hasError('required')">
						<span>Datapoint Name is required</span>
					</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Description:</mat-label>
					<input matInput autocomplete="off" formControlName="PVDescription">
					<mat-error *ngIf="dialogForm.get('PVDescription')!.hasError('required')">
						<span>Description is required</span>
					</mat-error>
				</mat-form-field>
				<div>
					<mat-label>Units:</mat-label>
					<ejs-dropdownlist style="background-color: #F5F5F5;" id='Units' #UnitsDropdown
						[dataSource]='siUnits' (change)='onUnitsChange($event)' [value]='dialogForm.get("SI")?.value'
						[fields]='fields' [placeholder]='waterMark' [popupHeight]='120'>
					</ejs-dropdownlist>
				</div>
				<ejs-accordion style="margin-top: 1em; border-radius: var(--default-border-radius);">
					<e-accordionitems>
						<e-accordionitem>
							<ng-template #header>
								<div><span>Advanced Settings</span></div>
							</ng-template>
							<ng-template #content>
								<div class="md-form mb-1 matFormSlider">
									<div>
										<mat-label>Is Cumulative DataPoint</mat-label>
										<mat-slide-toggle #switchIsCumulative formControlName="IsCumulative"
											color="primary"></mat-slide-toggle>
									</div>
								</div>

								<div class="binaryData">
									<ejs-checkbox #checkbox label="Binary Value"
										formControlName="IsBinary"></ejs-checkbox>
									<div class="binaryDataArea" *ngIf="checkbox.checked">
										<mat-form-field>
											<mat-label>Value 'On':</mat-label>
											<input matInput autocomplete="off" formControlName="BinaryOnValue">
										</mat-form-field>
										<mat-form-field>
											<mat-label>Value 'Off':</mat-label>
											<input matInput autocomplete="off" formControlName="BinaryOffValue">
										</mat-form-field>
										<mat-form-field>
											<mat-label>Threshold Value:</mat-label>
											<input matInput autocomplete="off" formControlName="BinaryThresholdValue">
										</mat-form-field>
									</div>
								</div>
							</ng-template>
						</e-accordionitem>
					</e-accordionitems>
				</ejs-accordion>
				<div class="md-form mb-1 matFormSlider" style="margin-top: 0.5em;">
					<div>
						<mat-label>Enabled for Data Collection</mat-label>
						<mat-slide-toggle #switchAdmin formControlName="Enabled" color="primary"></mat-slide-toggle>
					</div>
				</div>
				<div class="md-form mb-1 matFormSlider">
					<div>
						<mat-label>Enabled Offline Notification</mat-label>
						<mat-slide-toggle #switchOfflineNotification formControlName="EnableOffline"
							color="primary"></mat-slide-toggle>
					</div>
				</div>
				
				<!-- <app-image-container [imgURL]="dialogForm.get('ImageSrc')?.value" 
							 [enablePicture]="enablePicture"
							 [enableCamera]="enableCamera"
							 [enableDelete]="enableDelete"
							 (onDelete)="deleteImg()" 
							 (onNewImage)="onNewImage($event)"></app-image-container> -->
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button (click)="onSaveClick()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>